<template>
  <div class="field" v-show="visible">
    <div class="string-selection-container">
      <question-attributes :colors="colors" :field="field"></question-attributes>
      <input
        v-model="field.value"
        class="string-field string-field-input"
        type="text"
        :placeholder="field.hint"
        @focus="focus = true"
        @focusout="focus = false"
        :style="focus ? focusStyle : {}"
      />
      <div class="error" v-if="field.invalid && !field.value">This field is required</div>
    </div>
  </div>
</template>

<script>
    import Field from './Field'

    export default {
        name: 'StringField',
        extends: Field,
        computed: {
            focusStyle() {
                return {
                    borderBottomColor: this.colors.highlightColor
                }
            }
        },
        data() {
            return {
                focus: false
            }
        },
        props: ['field', 'colors']
    }
</script>

<style>
.string-selection-container input[type=text].string-field.string-field-input {
  border: solid 1px #bfc0c8;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.14);
  border-radius: 5px;
  font-size: 13px;
  font-weight: 600;
  width: 95%;
  margin: 0 auto;
  padding: 0 10px;
}
.string-selection-container input[type=text].string-field.string-field-input:focus {
    outline: 0;
    border-bottom-color: #00aef1;
}
</style>
